import React, { useRef, useState, useEffect } from "react";
import "../styles/SetSection.css";
import { useDispatch } from "react-redux";
import { SetPopupReducerData } from "../store/reducer/PopupReducer";
import { useNavigate, useParams } from "react-router-dom";
import EventLineDrawer from "../Components/popup/DrawEvent";
import {
  GetExistingEvent,
  setEventRecord,
  UpdateEventCamera,
  UseCaseeventListApi,
} from "../api/api";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import axios from "axios";

const SetSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = useParams();
  //console.log("id", id?.id);
  const [drawingEnabled, setDrawingEnabled] = useState(false);
  const [drawMode, setDrawMode] = useState("line");
  const [isDrawing, setIsDrawing] = useState(false);
  const [lines, setLines] = useState([]);
  const [currentLine, setCurrentLine] = useState([]);
  const [lastLine, setLastLine] = useState(null);
  const [draggingPointIndex, setDraggingPointIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [useCase, setUseCase] = useState([]);
  const [lineOrientation, setLineOrientation] = useState(null);
  const [showDirectionSelect, setShowDirectionSelect] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [inputData, setInputData] = useState({ use_case: "" });
  const [restrictedSide, setRestrictedSide] = useState("");
  const [name, setName] = useState("");
  const imageRef = useRef(null);
  const canvasRef = useRef(null);
  const audioRef = useRef(null);
  const [isedit, setIsEdit] = useState(false);
  const [eventId, setEventId] = useState("");

  const FetchDetailEvent = async () => {
    try {
      const fetchData = await GetExistingEvent(id?.id);
      const event = fetchData?.data?.data?.[0];
      //console.log("event", event);
      setEventId(event?._id);
      if (event?.coordinates && event?.coordinates.length > 0) {
        const formattedPoints = event.coordinates.map(([x, y]) => ({ x, y }));

        setLines([
          {
            points: formattedPoints,
            orientation: "inside",
            direction: "left",
          },
        ]);
        setIsEdit(true);
        setDrawMode(event.shape_type || "polygon");
        setDrawingEnabled(true);
      }

      //console.log("fetchData", fetchData?.data?.data);
    } catch (error) {
      //console.log("error", error);
    }
  };

  const getCanvasPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  };

  const fetchUseCase = async () => {
    try {
      const data = await UseCaseeventListApi();
      console.log("data", data);
      if (data?.data?.status === true) {
        setUseCase(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchUseCase();
    FetchDetailEvent();
  }, [id?.id]);

  const handleDrawClick = () => {
    setDrawingEnabled(true);
    setLines([]);
    setCurrentLine([]);
  };

  const handleMouseDown = (e) => {
    const pos = getCanvasPos(e);
    if (!drawingEnabled) return;

    if (drawMode === "line" && lines.length > 0) {
      const line = lines[0];
      const [start, end] = line.points;
      const distance = (a, b) => Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);
      const threshold = 10;

      if (distance(pos, start) < threshold) {
        setDraggingPointIndex(0);
        return;
      } else if (distance(pos, end) < threshold) {
        setDraggingPointIndex(1);
        return;
      }
    }

    if (drawMode === "line") {
      setIsDrawing(true);
      setCurrentLine([pos]);
    } else {
      setCurrentLine((prev) => [...prev, pos]);
    }
  };

  const handleMouseMove = (e) => {
    const pos = getCanvasPos(e);

    if (draggingPointIndex !== null && lines.length > 0) {
      const updatedLines = [...lines];
      const updatedPoints = [...updatedLines[0].points];
      updatedPoints[draggingPointIndex] = pos;
      updatedLines[0].points = updatedPoints;
      setLines(updatedLines);
      const [start, end] = updatedPoints;
      setLastLine({ x1: start.x, y1: start.y, x2: end.x, y2: end.y });
      return;
    }

    if (!isDrawing || drawMode !== "line" || !drawingEnabled) return;
    setCurrentLine((prev) => [...prev, getCanvasPos(e)]);
  };

  const handleMouseUp = () => {
    if (draggingPointIndex !== null) {
      setDraggingPointIndex(null);
      return;
    }

    if (!drawingEnabled) return;

    if (drawMode === "line" && currentLine.length > 1) {
      const start = currentLine[0];
      const end = currentLine[currentLine.length - 1];
      const dx = Math.abs(end.x - start.x);
      const dy = Math.abs(end.y - start.y);
      const THRESHOLD = 10;
      let orientation = dx > dy ? "horizontal" : "vertical";
      if (dx < THRESHOLD && dy >= THRESHOLD) orientation = "vertical";
      if (dy < THRESHOLD && dx >= THRESHOLD) orientation = "horizontal";

      const lineData = {
        points: [start, end],
        orientation: "inside",
        direction: "left",
      };

      setLines([lineData]);
      setLastLine({ x1: start.x, y1: start.y, x2: end.x, y2: end.y });
      setLineOrientation(orientation);
      setShowDirectionSelect(true);
      setCurrentLine([]);
    }

    setIsDrawing(false);
  };

  const handleCompletePolygon = async () => {
    if (drawMode === "polygon" && currentLine.length >= 3) {
      const polygonPoints = currentLine.map((p) => [
        Math.round(p.x),
        Math.round(p.y),
      ]);

      let camera_url = localStorage.getItem("rtsp_url");
      let payload = {
        coordinates: polygonPoints,
        camera_id: id.id,
        camera_url: camera_url,
        shape_type: drawMode,
        usecase_id: inputData.use_case,
        // "68774aa066e08ec492e922d3",
        action_type_ids: [],
        alert_type_ids: [],
        restricted_type: "",
        event_name: name,
        event_id: eventId ? eventId : "",
      };

      try {
        // const response = await axios.post(
        //   "https://visionqueuewaitingapi.greymatterz.com/polygon",
        //   {
        //     polygon_coords: polygonPoints,
        //     camera_id: id.id,
        //     camera_url: camera_url,
        //     shape_type: drawMode,
        //     usecase_id: inputData.use_case,
        //     // "68774aa066e08ec492e922d3",
        //     action_type_ids: [],
        //     alert_type_ids: [],
        //     restricted_type: "",
        //     event_name: name,
        //   }
        // );
        // if (response) {
        //   toast.success("Polygon data sent successfully!");
        //   setShowDrawer();
        // }
        if (isedit) {
          const eventResponse = await UpdateEventCamera(payload);
          if (eventResponse?.data?.status) {
            setShowDrawer(false);
            toast.success("Event updated successfully!");
          } else toast.error("Something went wrong!");
        } else {
          const eventResponse = await setEventRecord(payload);
          if (eventResponse?.data?.status) {
            setShowDrawer(false);
            toast.success("Event saved successfully!");
          } else toast.error("Something went wrong!");
        }
      } catch (error) {
        console.error("Error sending polygon data:", error);
        toast.error("Failed to send polygon data.");
      }
      setLines((prev) => [...prev, currentLine]);
    } else {
      toast.warn("Please draw at least 3 points to complete the polygon.");
    }
  };

  //  const handleDirectionSelect = (e) => {
  //   const direction = e.target.value;
  //   setRestrictedSide(direction);
  //   // if (lastLine) {
  //   //   socket.emit("set_line", { ...lastLine, restricted_side: direction });
  //   // }
  //   setShowDirectionSelect(false);
  //   setLastLine(null);
  // };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.lineWidth = 2;
    ctx.strokeStyle = "#00AEEF";

    lines.forEach((line) => {
      const points = line.points;
      if (!points || points.length < 2) return;

      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);
      points.forEach((p, i) => {
        if (i > 0) ctx.lineTo(p.x, p.y);
      });

      if (drawMode === "polygon") ctx.closePath();
      ctx.stroke();

      points.forEach((pt) => {
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, 4, 0, 2 * Math.PI);
        ctx.fillStyle = "blue";
        ctx.fill();
      });

      if (drawMode === "line") {
        const [start, end] = points;
        const midX = (start.x + end.x) / 2;
        const midY = (start.y + end.y) / 2;
        const angle = Math.atan2(end.y - start.y, end.x - start.x);
        const offset = 12;
        const offsetX = offset * Math.cos(angle + Math.PI / 2);
        const offsetY = offset * Math.sin(angle + Math.PI / 2);

        const drawTriangle = (x, y, angle, color) => {
          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(angle);
          ctx.beginPath();
          ctx.moveTo(0, -10);
          ctx.lineTo(-5, 5);
          ctx.lineTo(5, 5);
          ctx.closePath();
          ctx.fillStyle = color;
          ctx.fill();
          ctx.restore();
        };

        drawTriangle(midX + offsetX, midY + offsetY, angle + Math.PI, "red");
        drawTriangle(midX - offsetX, midY - offsetY, angle, "green");
      }
    });

    if (currentLine.length > 0) {
      ctx.beginPath();
      currentLine.forEach((point, index) => {
        index === 0
          ? ctx.moveTo(point.x, point.y)
          : ctx.lineTo(point.x, point.y);
      });
      ctx.stroke();
    }
  }, [lines, currentLine]);

  const handleSubmit = async () => {
    if (!lines.length) return toast.warn("No shape drawn!");
    if (!inputData.use_case) return toast.warn("Please select a use case.");
    setLoading(true);

    try {
      const shape = lines[lines.length - 1];
      const coordinates = shape.points.map((point) => [
        Math.round(point.x),
        Math.round(point.y),
      ]);
      const payload = {
        camera_id: id?.id,
        coordinates,
        shape_type: drawMode,
        action_type_ids: [],
        alert_type_ids: [],
        usecase_id: inputData.use_case,
        restricted_type: restrictedSide,
        event_name: name,
      };

      const response = await setEventRecord(payload);
      if (response?.data?.status) {
        setShowDrawer(false);
        toast.success("Event saved successfully!");
      } else toast.error("Something went wrong!");
    } catch (err) {
      toast.error("Error saving event!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="entranceGroup">
        <IoIosArrowBack size={22} /> Camera / Entrance Group
      </div>
      <div className="container mt-5">
        <div className="image-area-wrapper">
          <div
            className="image-container"
            ref={imageRef}
            style={{ position: "relative", width: "960px", height: "540px" }}
          >
            <img
              src={`https://visionemptrack.greymatterz.com/stream2/stream2/${
                id.id
              }?t=${Date.now()}`}
              alt="Camera Feed"
              className="camera-image"
            />
            {drawingEnabled && (
              <canvas
                ref={canvasRef}
                width={960}
                height={540}
                style={{ position: "absolute", top: 0, left: 0 }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
              />
            )}
          </div>

          <audio ref={audioRef} src="/alert.mp3" preload="auto" />

          <div className="button-group">
            <button className="action-btn" onClick={() => setShowDrawer(true)}>
              Add Event
            </button>

            <button
              className="action-btn"
              onClick={() => {
                setDrawingEnabled(false);
                dispatch(
                  SetPopupReducerData({
                    modalType: "setalert",
                    showModal: true,
                    camera_id: id?.id,
                  })
                );
              }}
            >
              Set Alert
            </button>
            <button
              className="action-btn"
              onClick={() => {
                setDrawingEnabled(false);
                dispatch(
                  SetPopupReducerData({
                    modalType: "setaction",
                    showModal: true,
                  })
                );
              }}
            >
              Set Action
            </button>

            <button
              className="action-btn"
              onClick={() => {
                navigate(`/seat-detection/${id?.id}`);
              }}
            >
              Set Seat detection
            </button>
          </div>
        </div>

        {showDrawer && (
          <EventLineDrawer
            onClose={() => setShowDrawer(false)}
            onSubmit={(data) => {
              //console.log("Event Data Submitted:", data);
              handleSubmit();
              setShowDrawer(false);
            }}
            handleDrawClick={(mode) => {
              setDrawMode(mode);
              handleDrawClick();
            }}
            useCaseId={inputData.use_case}
            setUseCaseId={(value) =>
              setInputData((prev) => ({ ...prev, use_case: value }))
            }
            restrictedSide={restrictedSide}
            setRestrictedSide={setRestrictedSide}
            useCaseList={useCase}
            lineOrientation={lineOrientation}
            showDirectionSelect={showDirectionSelect}
            setShowDirectionSelect={setShowDirectionSelect}
            setName={setName}
            name={name}
            drawMode={drawMode}
            currentLine={currentLine}
            handleCompletePolygon={() => {
              handleCompletePolygon();
            }}
            isName={false}
          />
        )}
      </div>
    </>
  );
};

export default SetSection;
